import { lazy } from '@/service/lazy'

export default [{
  name: 'Planos de Assinatura',
  path: 'planos-assinatura',
  id: 'planos-assinatura',
  icon: 'fa fa-list-alt',
  component: lazy('app/default/adm_financeiro/planosassinaturas/index'),
  meta: { requireAuth: true, rules: ['gerenciar_planos_assinatura'], root: true },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/planosassinaturas.js